module.exports = __webpack_public_path__ + "static/media/flat-tire-banesco-selected.1e324daf.svg";